/* global Swiper */

/** @type {import('swiper').Swiper} */
export const carouselHero = new Swiper('.section-hero-carousel .swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    direction: 'horizontal',
    pagination: {
        el: '.section-hero-carousel .swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.section-hero-carousel .swiper-button-next',
        prevEl: '.section-hero-carousel  .swiper-button-prev'
    }
})
